import React, { useEffect, useState } from "react";
import "./Upcoming.css";
import { Accordion } from "react-bootstrap";
import { Vaccination_img } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { vaccineListApi } from "services/vaccineRecord";
import { dateFormatWithTime } from "utils/dateFormat";

const Upcoming = ({ _child, status }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [trackingList, setTrackingList] = useState([]);
  const [selectedVaccine, setSelectedVaccine] = useState({});
  const [meta, setMeta] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data } = await vaccineListApi({ childId: _child, status });
      setTrackingList(data?.data);
      setMeta(data?.meta);

      if (data?.data?.length) {
        setSelectedVaccine(data?.data[0]);
      } else {
        setSelectedVaccine({});
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, [status]);

  return (
    <>
      <div className={status === "UPCOMING" ? "Upcoming_parent" : status === "MISSED" ? "Missed_parent" : "Completed_parent"}>
        <div className={status === "UPCOMING" ? "upcoming_wraper" : status === "MISSED" ? "Missed_wraper" : "Completed_wraper"}>
          <div className="vaccination_record_left">
            <div className="vaccination_accordion">
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="left_accordian">
                    <Accordion>
                      {
                        trackingList.map(vaccine => (
                          <Accordion.Item eventKey={vaccine._id}>
                            <Accordion.Header onClick={() => setSelectedVaccine(vaccine)}>
                              <div className="first_accordian_content">
                                <div className="accordian_text">
                                  <b>{vaccine?.vaccineName}</b>
                                  <div className="accordian_down">
                                    <ul>
                                      <li>
                                        {dateFormatWithTime(vaccine?.createdAt)}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Header>
                          </Accordion.Item>
                        ))
                      }
                    </Accordion>
                  </div>
                </div>

                {
                  selectedVaccine?._id
                    ?
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <div className="doctor_visit_rgt">
                        <div className="doctor_visit_card">
                          <div className="date-time">
                            Doctor Name
                            <br />
                            <p>{selectedVaccine?.doctorName}</p>
                          </div>

                          <div className="date-time">
                            Date & Time
                            <br />
                            <p>{dateFormatWithTime(selectedVaccine?.createdAt)}</p>
                          </div>

                          {/* <div className="date-time">
                            Reaction(Optional)
                            <br />
                            <p>{selectedVaccine?.note}</p>
                          </div> */}

                          <div className="image-wraper">
                            <img src={selectedVaccine?.image?.length ? selectedVaccine?.image : Vaccination_img} alt="Vaccination" />
                          </div>

                          <div className="motorskilltracking-note">
                            <p>
                              {
                                selectedVaccine?.note
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    :
                    null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upcoming;
